export default "__VITE_ASSET__YpOOqMmy__"